import { Button, Card, Col, Flex, Form, Input, Row, Space } from "antd";
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { useState } from "react";
import { AuthService } from "../../services/AuthService";
import { toast } from "react-toastify";
import { mdlResetPasswordRequest } from "../../models/service-models/auth/ResetPasswordRequest";
import { useNavigate } from "react-router-dom";
import { routeContants } from "../../utils/RouteConstants";


export type PasswordResetModalProps = {
    callback?: Function;
    userName?: string;
    onClose?: Function;
}

const PasswordResetModal = (props: PasswordResetModalProps) => {
    const { t } = useTranslation();
    const [request, setRequest] = useState<mdlResetPasswordRequest>();
    const [form] = Form.useForm();
    const navigate = useNavigate();


    const { mutateAsync, isLoading, data } = useMutation(
        (data: mdlResetPasswordRequest) => {
            return AuthService.ResetPassword(data)
        },
        {
            onMutate(variables) {
                variables.username = props.userName;
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header.success && data.body?.isSuccessful) {
                    toast.success(t("auth.reset.resetSuccess"));
                    setTimeout(() => {
                        navigate(routeContants.DASHBOARD);
                    }, 5000);
                }
                else {
                    if (data.body && !data.body?.isSuccessful)
                        toast.error(data.body?.message);
                    else if (data.header.messages) {
                        toast.error(_.first(data.header.messages)?.message);
                    }
                }
                // if (data.header && data.header.success && data.body && data.body.userInfo) {
                // //   data.body.userInfo.firstName = data.body.userInfo.userName; //TODO
                // //   data.body.userInfo.lastName = data.body.userInfo.userName; //TODO
                // //   data.body.userInfo.mail = data.body.userInfo.userName; //TODO
                // //   dispatch(setUser(data.body.userInfo));
                // //   dispatch(setUserHotels(data.body.userInfo.hotels));
                // //   dispatch(setToken(data.body.userInfo.token));
                // //   dispatch(setCrossAgencies(data.body.userInfo.crossAgencies));
                // //   dispatch(setHotelUserPermissions(data.body.userInfo.permissions));
                // //   dispatch(setHotelUserPairs(data.body.userInfo.hotelUserPairs));
                // //   navigate(routeContants.DASHBOARD);
                // } else {
                //   //dispatch(toUnLoading());
                //   toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                // }
            },
        }
    );



    return (
        <Card loading={isLoading}>
            <Form
                form={form}
                name="send-action-mail-form"
                layout="vertical"
                onFinish={async (values) => await mutateAsync(values)}
                autoComplete="off"
            >
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item<mdlResetPasswordRequest>
                            label={t("auth.reset.oldPassword")}
                            name={'oldPassword'}
                            rules={[
                                { required: true, message: t("common.required") },
                            ]}
                        >
                            <Input type="password" />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item<mdlResetPasswordRequest>
                            label={t("auth.reset.newPassword")}
                            name={'newPassword'}
                            rules={[
                                { required: true, message: t("common.required") },
                                { min: 8, message: t("common.minEight") },
                            ]}
                        >
                            <Input type="password" />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item<mdlResetPasswordRequest>
                            label={t("auth.reset.passwordConfirm")}
                            name={'passwordConfirm'}
                            rules={[
                                { required: true, message: t("common.required") },
                                { min: 8, message: t("common.minEight") },
                            ]}
                        >
                            <Input type="password" />
                        </Form.Item>
                    </Col>

                </Row>
                <Row style={{ marginTop: "25px" }} justify={"end"}>
                    <Form.Item>
                        <Flex align={"center"} justify="flex-end">
                            <Space>
                                <Button type="primary" htmlType="submit">{t("common.save")}</Button>
                                <Button type="primary" onClick={() => props.onClose && props.onClose()} danger htmlType="button">{t("common.close")}</Button>
                            </Space>
                        </Flex>

                    </Form.Item>
                </Row>
            </Form>
        </Card>
    )
}

export default PasswordResetModal;